import DriverShelters from "../../../views/DriverShelters/index.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverSheltersRoutes = [
  {
    menuName: MenuNames.DRIVER_SHELTER,
    path: "/driver-shelter",
    component: DriverShelters,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_SHELTER,
    path: "/driver-shelter/:id(\\d+)",
    component: DriverShelters,
    exact: true,
  },
];

export default DriverSheltersRoutes;
